import script from "./SsoUserPopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./SsoUserPopover.vue?vue&type=script&lang=ts&setup=true"

import "./SsoUserPopover.vue?vue&type=style&index=0&id=44291d52&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44291d52"]])

export default __exports__